// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ep-content {
  margin-top: 1rem;
  padding: 1rem 1rem;
  background-color: var(--ods-color-gray-10);
  font-size: 0.875rem;
}
.ep-content__header {
  padding-bottom: 0.5rem;
}
.ep-content__header--fontstyle {
  font-style: italic;
}
.ep-content__links {
  display: flex;
  justify-content: space-between;
}
.ep-content__links-group orchid-link {
  margin-left: 1rem;
}

@media print {
  .no-print {
    display: none !important;
  }
  .ep-content {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/main/footer/footer.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,mBAAA;AACF;AACE;EACE,sBAAA;AACJ;AACI;EACE,kBAAA;AACN;AAGE;EACE,aAAA;EACA,8BAAA;AADJ;AAIM;EACE,iBAAA;AAFR;;AAQA;EACE;IACE,wBAAA;EALF;EAQA;IACE,wBAAA;EANF;AACF","sourcesContent":[".ep-content {\n  margin-top: 1rem;\n  padding: 1rem 1rem;\n  background-color: var(--ods-color-gray-10);\n  font-size: 0.875rem;\n\n  &__header {\n    padding-bottom: 0.5rem;\n\n    &--fontstyle {\n      font-style: italic;\n    }\n  }\n\n  &__links {\n    display: flex;\n    justify-content: space-between;\n\n    &-group {\n      orchid-link {\n        margin-left: 1rem;\n      }\n    }\n  }\n}\n\n@media print {\n  .no-print {\n    display: none !important;\n  }\n\n  .ep-content {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
